// СГЕНЕРИРОВАНО генератором миссий (developer_artifacts/scripts/missionGen).
// Правится не руками, а перегенерацией: npx tsx developer_artifacts/scripts/missionGen/generate_humans_6.cjs
/* eslint-disable */
const mission = {
  "id": "humans_6",
  "campaignFactionId": "humans",
  "order": 6,
  "title": "Рубикон",
  "shortTitle": "Миссия VI",
  "description": "Перейди реку, о которой ещё не сложили поговорок, и возьми ворота Италии",
  "finalRound": 11,
  "reward": {
    "type": "chest",
    "chestId": "chest_random_epic"
  },
  "rewardIfFactionOwned": null,
  "playerColor": "blue",
  "players": [
    {
      "name": "Луций",
      "color": "blue",
      "factionId": "humans",
      "selectedSkin": "humans_default",
      "isBot": false,
      "bonus": "none"
    },
    {
      "name": "Когорты Суллы",
      "color": "violet",
      "factionId": "humans",
      "selectedSkin": "humans_default",
      "isBot": true,
      "bonus": "none"
    },
    {
      "name": "Дом Весов",
      "color": "orange",
      "factionId": "ventory",
      "selectedSkin": "ventory_default",
      "isBot": true,
      "bonus": "none"
    }
  ],
  "field": {
    "hexes": {
      "-14,0": "sea",
      "-13,0": "sea",
      "-12,0": "sea",
      "-11,0": "sea",
      "-10,0": "sea",
      "-9,0": "sea",
      "-8,0": "sea",
      "-7,0": "sea",
      "-6,0": "sea",
      "-5,0": "sea",
      "-4,0": "sea",
      "-3,0": "sea",
      "-2,0": "sea",
      "-1,0": "sea",
      "1,0": "sea",
      "2,0": "sea",
      "3,0": "sea",
      "4,0": "sea",
      "5,0": "sea",
      "6,0": "sea",
      "7,0": "sea",
      "8,0": "sea",
      "9,0": "sea",
      "10,0": "sea",
      "11,0": "sea",
      "12,0": "sea",
      "13,0": "sea",
      "14,0": "sea",
      "0,0": "road",
      "8,-6": "sea",
      "8,-5": "sea",
      "8,-4": "sea",
      "8,-3": "sea",
      "8,-2": "sea",
      "8,-1": "sea",
      "8,1": "sea",
      "8,2": "sea",
      "8,3": "sea",
      "8,4": "sea",
      "8,5": "sea",
      "8,6": "sea",
      "8,7": "sea",
      "8,8": "sea",
      "8,9": "sea",
      "8,10": "sea",
      "9,-6": "sea",
      "9,-5": "sea",
      "9,-4": "sea",
      "9,-3": "sea",
      "9,-2": "sea",
      "9,-1": "sea",
      "9,1": "sea",
      "9,2": "sea",
      "9,3": "sea",
      "9,4": "sea",
      "9,5": "sea",
      "9,6": "sea",
      "9,7": "sea",
      "9,8": "sea",
      "9,9": "sea",
      "9,10": "sea",
      "10,-6": "sea",
      "10,-5": "sea",
      "10,-4": "sea",
      "10,-3": "sea",
      "10,-2": "sea",
      "10,-1": "sea",
      "10,1": "sea",
      "10,2": "sea",
      "10,3": "sea",
      "10,4": "sea",
      "10,5": "sea",
      "10,6": "sea",
      "10,7": "sea",
      "10,8": "sea",
      "10,9": "sea",
      "10,10": "sea",
      "11,-6": "sea",
      "11,-5": "sea",
      "11,-4": "sea",
      "11,-3": "sea",
      "11,-2": "sea",
      "11,-1": "sea",
      "11,1": "sea",
      "11,2": "sea",
      "11,3": "sea",
      "11,4": "sea",
      "11,5": "sea",
      "11,6": "sea",
      "11,7": "sea",
      "11,8": "sea",
      "11,9": "sea",
      "12,-6": "sea",
      "12,-5": "sea",
      "12,-4": "sea",
      "12,-3": "sea",
      "12,-2": "sea",
      "12,-1": "sea",
      "12,1": "sea",
      "12,2": "sea",
      "12,3": "sea",
      "12,4": "sea",
      "12,5": "sea",
      "12,6": "sea",
      "12,7": "sea",
      "12,8": "sea",
      "13,-6": "sea",
      "13,-5": "sea",
      "13,-4": "sea",
      "13,-3": "sea",
      "13,-2": "sea",
      "13,-1": "sea",
      "13,1": "sea",
      "13,2": "sea",
      "13,3": "sea",
      "13,4": "sea",
      "13,5": "sea",
      "13,6": "sea",
      "13,7": "sea",
      "14,-6": "sea",
      "14,-5": "sea",
      "14,-4": "sea",
      "14,-3": "sea",
      "14,-2": "sea",
      "14,-1": "sea",
      "14,1": "sea",
      "14,2": "sea",
      "14,3": "sea",
      "14,4": "sea",
      "14,5": "sea",
      "14,6": "sea",
      "-2,-3": "flag_blue",
      "-1,-3": "quarter",
      "-3,-3": "quarter",
      "-2,-4": "quarter",
      "-2,-2": "farm",
      "-1,-4": "farm",
      "0,-4": "farm",
      "-4,-2": "farm",
      "-3,-4": "farm",
      "-2,-5": "farm",
      "-3,-2": "barracks",
      "0,-3": "road",
      "0,-2": "road",
      "0,-1": "road",
      "-1,1": "farm",
      "1,1": "farm",
      "-1,2": "mountain",
      "0,2": "road",
      "1,2": "road",
      "1,3": "road",
      "2,3": "road",
      "2,2": "road",
      "0,3": "ruins",
      "3,2": "road",
      "4,1": "road",
      "5,1": "road",
      "2,1": "road",
      "3,1": "road",
      "2,5": "flag_violet",
      "2,4": "quarter",
      "3,5": "quarter",
      "2,6": "quarter",
      "1,5": "farm",
      "1,6": "farm",
      "1,7": "farm",
      "3,4": "farm",
      "4,5": "farm",
      "2,7": "farm",
      "3,6": "barracks",
      "5,2": "flag_orange",
      "6,2": "quarter",
      "4,2": "farm",
      "6,1": "farm",
      "-5,3": "mountain",
      "-5,4": "mountain",
      "-4,2": "mountain",
      "-4,3": "mountain",
      "-4,4": "mountain",
      "-3,2": "mountain",
      "-3,3": "mountain",
      "-8,-5": "mountain",
      "-8,-4": "mountain",
      "-7,-6": "mountain",
      "-7,-5": "mountain",
      "-7,-4": "mountain",
      "-6,-6": "mountain",
      "-6,-5": "mountain",
      "3,-3": "mountain",
      "3,-2": "mountain",
      "4,-4": "mountain",
      "4,-3": "mountain",
      "4,-2": "mountain",
      "5,-4": "mountain",
      "5,-3": "mountain",
      "-16,0": "sea",
      "-16,1": "sea",
      "-16,2": "sea",
      "-16,3": "sea",
      "-16,4": "sea",
      "-16,5": "sea",
      "-16,6": "sea",
      "-16,7": "sea",
      "-16,8": "sea",
      "-16,9": "sea",
      "-16,10": "sea",
      "-16,11": "sea",
      "-16,12": "sea",
      "-16,13": "sea",
      "-16,14": "sea",
      "-16,15": "sea",
      "-16,16": "sea",
      "-15,-1": "sea",
      "-15,16": "sea",
      "-14,-2": "sea",
      "-14,16": "sea",
      "-13,-3": "sea",
      "-13,16": "sea",
      "-12,-4": "sea",
      "-12,16": "sea",
      "-11,-5": "sea",
      "-11,16": "sea",
      "-10,-6": "sea",
      "-10,16": "sea",
      "-9,-7": "sea",
      "-9,16": "sea",
      "-8,-8": "sea",
      "-8,16": "sea",
      "-7,-9": "sea",
      "-7,16": "sea",
      "-6,-10": "sea",
      "-6,16": "sea",
      "-5,-11": "sea",
      "-5,16": "sea",
      "-4,-12": "sea",
      "-4,16": "sea",
      "-3,-13": "sea",
      "-3,16": "sea",
      "-2,-14": "sea",
      "-2,16": "sea",
      "-1,-15": "sea",
      "-1,16": "sea",
      "0,-16": "sea",
      "0,16": "sea",
      "1,-16": "sea",
      "1,15": "sea",
      "2,-16": "sea",
      "2,14": "sea",
      "3,-16": "sea",
      "3,13": "sea",
      "4,-16": "sea",
      "4,12": "sea",
      "5,-16": "sea",
      "5,11": "sea",
      "6,-16": "sea",
      "6,10": "sea",
      "7,-16": "sea",
      "7,9": "sea",
      "8,-16": "sea",
      "9,-16": "sea",
      "10,-16": "sea",
      "11,-16": "sea",
      "12,-16": "sea",
      "13,-16": "sea",
      "14,-16": "sea",
      "15,-16": "sea",
      "15,1": "sea",
      "16,-16": "sea",
      "16,-15": "sea",
      "16,-14": "sea",
      "16,-13": "sea",
      "16,-12": "sea",
      "16,-11": "sea",
      "16,-10": "sea",
      "16,-9": "sea",
      "16,-8": "sea",
      "16,-7": "sea",
      "16,-6": "sea",
      "16,-5": "sea",
      "16,-4": "sea",
      "16,-3": "sea",
      "16,-2": "sea",
      "16,-1": "sea",
      "16,0": "sea"
    },
    "units": [
      {
        "id": "u_blue_0_-1_-3",
        "hexKey": "-1,-3",
        "ownerId": "player_id_blue",
        "type": "unit_d10",
        "size": 8,
        "maxSize": 10
      },
      {
        "id": "u_blue_1_-2_-4",
        "hexKey": "-2,-4",
        "ownerId": "player_id_blue",
        "type": "unit_d10",
        "size": 8,
        "maxSize": 10
      },
      {
        "id": "u_blue_2_-3_-3",
        "hexKey": "-3,-3",
        "ownerId": "player_id_blue",
        "type": "unit_d6",
        "size": 6,
        "maxSize": 6
      },
      {
        "id": "u_blue_3_-3_-4",
        "hexKey": "-3,-4",
        "ownerId": "player_id_blue",
        "type": "unit_d6",
        "size": 6,
        "maxSize": 6
      },
      {
        "id": "u_blue_4_-1_-4",
        "hexKey": "-1,-4",
        "ownerId": "player_id_blue",
        "type": "unit_d8",
        "size": 4,
        "maxSize": 8
      },
      {
        "id": "u_blue_5_-2_-2",
        "hexKey": "-2,-2",
        "ownerId": "player_id_blue",
        "type": "unit_d8",
        "size": 4,
        "maxSize": 8
      },
      {
        "id": "u_violet_6_2_4",
        "hexKey": "2,4",
        "ownerId": "player_id_violet",
        "type": "unit_d4",
        "size": 4,
        "maxSize": 4
      },
      {
        "id": "u_violet_7_2_5",
        "hexKey": "2,5",
        "ownerId": "player_id_violet",
        "type": "unit_d10",
        "size": 8,
        "maxSize": 10
      },
      {
        "id": "u_violet_8_3_5",
        "hexKey": "3,5",
        "ownerId": "player_id_violet",
        "type": "unit_d6",
        "size": 6,
        "maxSize": 6
      },
      {
        "id": "u_violet_9_2_6",
        "hexKey": "2,6",
        "ownerId": "player_id_violet",
        "type": "unit_d6",
        "size": 6,
        "maxSize": 6
      },
      {
        "id": "u_violet_10_2_3",
        "hexKey": "2,3",
        "ownerId": "player_id_violet",
        "type": "unit_d8",
        "size": 4,
        "maxSize": 8
      },
      {
        "id": "u_orange_11_6_2",
        "hexKey": "6,2",
        "ownerId": "player_id_orange",
        "type": "unit_d6",
        "size": 4,
        "maxSize": 6
      }
    ],
    "specialBuildings": {
      "2,4": "fortress",
      "5,2": "guild",
      "6,2": "warehouse"
    },
    "gridConfig": {
      "radius": 20,
      "hexSize": 60,
      "orientation": "flat"
    }
  },
  "policyMarket": [
    {
      "id": "despotism",
      "name": "Деспотизм",
      "description": "Скидка на найм отрядов\nСкидка на постройку Лагеря",
      "implemented": true
    },
    {
      "id": "industrialism",
      "name": "Индустриализм",
      "description": "Дополнительное действие\nв фазе Строительства\nСкидка на особые строения",
      "implemented": true
    },
    {
      "id": "isolationism",
      "name": "Изоляционизм",
      "description": "Защита права первого хода\nСкидка на особые строения\nБонус к урону отрядов в своих городах",
      "implemented": true
    },
    {
      "id": "ecoanarchism",
      "name": "Экоанархизм",
      "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
      "implemented": true
    },
    {
      "id": "agrarianism",
      "name": "Аграризм",
      "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
      "implemented": true
    },
    {
      "id": "fanaticism",
      "name": "Фанатизм",
      "description": "Увеличенный доход руин\nБонус к урону отрядов смежно с руинами\nОбмен очков на монеты",
      "implemented": true
    }
  ],
  "script": [
    {
      "id": "e_0_replica",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "«Меня спросили вчера в курии, кому я служу: сенату или Риму. Я ответил как положено — что это одно и то же. Я солгал, Луций. Это не одно и то же, и всякий, кто носил орла, знает это к сорока годам. Молю богов, чтобы тебе не пришлось выбирать. А если придётся — выбери так, чтобы твой сын не краснел, читая твои письма. — М. Аврелий Скавр, сыну»",
        "characterName": "Из писем отца",
        "side": "left",
        "characterImage": "/img/campaigns/humans/letters_marc.png"
      }
    },
    {
      "id": "e_1_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h6_cross_rubicon",
        "type": "build_central_quarter",
        "params": {
          "hexKey": "0,1"
        },
        "text": "Поставь лагерь за Рубиконом — у старой ветлы за бродом: без него хутора того берега не кормят армию",
        "isMain": true,
        "isFailure": false
      }
    },
    {
      "id": "e_2_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h6_take_ariminum",
        "type": "capture_city",
        "params": {
          "centralHexKey": "2,5"
        },
        "text": "Возьми Аримин",
        "isMain": true,
        "isFailure": false
      }
    },
    {
      "id": "e_3_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h6_hear_rome",
        "type": "survive_rounds",
        "params": {
          "rounds": 11
        },
        "text": "Выслушай Рим",
        "isMain": true,
        "isFailure": false
      }
    },
    {
      "id": "e_4_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h6_break_tutela",
        "type": "destroy_all_enemy_units",
        "params": {
          "color": "violet"
        },
        "text": "Разбей когорты Суллы — гарнизон «Опеки» в Аримине",
        "isMain": false,
        "isFailure": false
      }
    },
    {
      "id": "e_5_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h6_open_granaries",
        "type": "unit_reaches_hex",
        "params": {
          "hexKey": "6,2"
        },
        "text": "Дойди отрядом до хлебных складов Дома Весов у порта",
        "isMain": false,
        "isFailure": false
      }
    },
    {
      "id": "e_6_objective",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "objective",
      "objective": {
        "id": "h6_lose_camp",
        "type": "lose_city",
        "params": {
          "centralHexKey": "-2,-3"
        },
        "text": "Не потеряй северный лагерь",
        "isMain": false,
        "isFailure": true
      }
    },
    {
      "id": "entry_7_SET_STARTING_QUARTER",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_STARTING_QUARTER",
        "payload": {
          "playerId": "player_id_violet",
          "hexKey": "2,5"
        }
      }
    },
    {
      "id": "entry_8_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 0,
          "currentPlayerId": "player_id_violet",
          "phase": "setup",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_9_SET_STARTING_QUARTER",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_STARTING_QUARTER",
        "payload": {
          "playerId": "player_id_orange",
          "hexKey": "5,2"
        }
      }
    },
    {
      "id": "entry_10_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 0,
          "currentPlayerId": "player_id_orange",
          "phase": "setup",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_11_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 0,
        "phase": "setup",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "ecoanarchism",
            "name": "Экоанархизм",
            "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
            "implemented": true
          },
          "round": 0,
          "currentPlayerId": "player_id_orange",
          "phase": "setup",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "e_12_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Из Рима, легат. Печать курии… и вторая печать. Весы.",
        "characterName": "Требоний",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m6_trebonius.png"
      }
    },
    {
      "id": "e_13_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "«Легату Л. Аврелию Скавру: армию распустить по эдикту Опеки; орлов сдать на хранение Дому Весов; самому прибыть в Рим для отчёта и почестей»… Почести. Требоний, ты видел Рим. Скажи им всем то, что сказал мне.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m6_lucius_stern.png"
      }
    },
    {
      "id": "e_14_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Рим цел. Целёхонек. Очереди у контор, весы над форумом, на Марсовом поле — серые учения чужой стражи. Рим цел, и Рим НЕ ШУМИТ. Я тридцать раз в него въезжал — он всегда шумел, как море. А теперь — тихо. Как… …как в Виктимулах тогда, легат. Как в погребе.",
        "characterName": "Требоний",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m6_trebonius.png"
      }
    },
    {
      "id": "e_15_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Моё слово короткое, легат: я присягал Риму. Кто из двух Римов настоящий — реши ты. Я исполню.",
        "characterName": "Атилий",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m6_atilius_calm.png"
      }
    },
    {
      "id": "e_16_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Я ходил за твоим отцом. Хожу за тобой. Куда — вам, Скаврам, виднее. Одно скажу, мальчик: обратно через эту речку бродов нет. Ни для кого из нас.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m6_barba_grim.png"
      }
    },
    {
      "id": "e_17_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Господин. Нам некуда распускаться. Твоя армия — это чей-то единственный дом. Помни это, когда будешь решать. Больше ничего не скажу.",
        "characterName": "Ильва",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m6_ilva_firm.png"
      }
    },
    {
      "id": "e_18_replica",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Отец писал: выбери так, чтобы сын не краснел… Сына у меня нет. Есть вы. Армия — переправляется. Лагерь ставим на ТОМ берегу. Пусть краснеет курия.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m6_lucius_resolve.png"
      }
    },
    {
      "id": "entry_19_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,5",
          "unitId": "u_violet_6_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_20_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "3,4",
          "unitId": "u_violet_10_2_3",
          "unitHexKey": "2,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_21_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,6",
          "unitId": "u_violet_7_2_5",
          "unitHexKey": "2,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_22_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,5",
          "unitId": "u_violet_8_3_5",
          "unitHexKey": "3,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_23_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,7",
          "unitId": "u_violet_9_2_6",
          "unitHexKey": "2,6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_24_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,7",
          "unitId": "u_violet_7_2_5",
          "unitHexKey": "2,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_25_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_26_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,2",
          "unitId": "u_orange_11_6_2",
          "unitHexKey": "6,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_27_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,1",
          "unitId": "u_orange_11_6_2",
          "unitHexKey": "6,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_28_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_29_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "hegemonism",
            "name": "Гегемонизм",
            "description": "Бонус к доходу очков и урону в центре поля",
            "implemented": true
          },
          "round": 1,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_30_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_31_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_32_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "totalitarianism",
            "name": "Тоталитаризм",
            "description": "Очки за военные строения\nСкидка на Лагерь и Арсенал\nНайм отрядов увеличенного размера",
            "implemented": true
          },
          "round": 1,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_33_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_34_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_35_MOVE_UNIT",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_violet_10_2_3",
          "unitType": "unit_d8",
          "newHexKey": "1,2"
        }
      }
    },
    {
      "id": "entry_36_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_violet_10_2_3",
          "fromHexKey": "2,3",
          "toHexKey": "1,2",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_37_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_38_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "shooting",
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_39_APPLY_SHOOTING_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_SHOOTING_ACTIONS"
      }
    },
    {
      "id": "entry_40_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_41_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_42_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_43_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_44_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 1,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_45_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 1,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_46_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 1,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "servarianism",
            "name": "Серваризм",
            "description": "Увеличенный доход рудников,\nсмежных казармам и крупными отрядам",
            "implemented": true
          },
          "round": 1,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_47_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,5",
          "unitId": "u_violet_6_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_48_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "3,4",
          "unitId": "u_violet_10_2_3",
          "unitHexKey": "1,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_49_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,6",
          "unitId": "u_violet_7_2_5",
          "unitHexKey": "2,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_50_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,5",
          "unitId": "u_violet_8_3_5",
          "unitHexKey": "3,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_51_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,7",
          "unitId": "u_violet_9_2_6",
          "unitHexKey": "2,6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_52_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,7",
          "unitId": "u_violet_7_2_5",
          "unitHexKey": "2,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_53_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_54_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,2",
          "unitId": "u_orange_11_6_2",
          "unitHexKey": "6,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_55_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,1",
          "unitId": "u_orange_11_6_2",
          "unitHexKey": "6,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_56_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_57_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "barbarism",
            "name": "Варварство",
            "description": "Бесплатный наем Пехоты\nУвеличенный урон в ближнем бою\nОчки за урон",
            "implemented": true
          },
          "round": 2,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_58_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_59_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_60_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "industrialism",
            "name": "Индустриализм",
            "description": "Дополнительное действие\nв фазе Строительства\nСкидка на особые строения",
            "implemented": true
          },
          "round": 2,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_61_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_62_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_63_MOVE_UNIT",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_violet_10_2_3",
          "unitType": "unit_d8",
          "newHexKey": "0,2"
        }
      }
    },
    {
      "id": "entry_64_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_violet_10_2_3",
          "fromHexKey": "1,2",
          "toHexKey": "0,2",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_65_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_66_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "shooting",
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_67_APPLY_SHOOTING_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_SHOOTING_ACTIONS"
      }
    },
    {
      "id": "entry_68_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_69_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_70_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_71_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_72_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 2,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_73_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 2,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_74_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 2,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "industrialism",
            "name": "Индустриализм",
            "description": "Дополнительное действие\nв фазе Строительства\nСкидка на особые строения",
            "implemented": true
          },
          "round": 2,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "e_75_replica",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "…Э, слыхал? Десятый уже зовёт брод «переправой легата». Приживётся — помяни моё слово. Всё великое так и зовётся — по мелкой воде да по живому человеку.",
        "characterName": "Легионер в строю",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m6_legioner.png"
      }
    },
    {
      "id": "e_76_replica",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "А почему все молчат? Река же мелкая.",
        "characterName": "Ансгар",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m6_ansgar_teen.png"
      }
    },
    {
      "id": "e_77_replica",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Потому, малец, что мелкие реки — самые глубокие. Вырастешь — не поймёшь, и не надо.",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m6_barba_tender.png"
      }
    },
    {
      "id": "entry_78_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,5",
          "unitId": "u_violet_6_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_79_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "3,4",
          "unitId": "u_violet_10_2_3",
          "unitHexKey": "0,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_80_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,6",
          "unitId": "u_violet_7_2_5",
          "unitHexKey": "2,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_81_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,5",
          "unitId": "u_violet_8_3_5",
          "unitHexKey": "3,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_82_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,7",
          "unitId": "u_violet_9_2_6",
          "unitHexKey": "2,6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_83_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,7",
          "unitId": "u_violet_7_2_5",
          "unitHexKey": "2,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_84_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_85_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,2",
          "unitId": "u_orange_11_6_2",
          "unitHexKey": "6,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_86_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,1",
          "unitId": "u_orange_11_6_2",
          "unitHexKey": "6,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_87_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_88_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "industrialism",
            "name": "Индустриализм",
            "description": "Дополнительное действие\nв фазе Строительства\nСкидка на особые строения",
            "implemented": true
          },
          "round": 3,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_89_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_90_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_91_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "militarism",
            "name": "Милитаризм",
            "description": "Увеличенный урон в ближнем бою",
            "implemented": true
          },
          "round": 3,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_92_RECRUIT_UNIT",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "RECRUIT_UNIT",
        "payload": {
          "hexKey": "3,6",
          "unitType": "unit_d6",
          "factionId": "humans",
          "price": 2,
          "unitId": "rec_violet_3_3_6"
        }
      }
    },
    {
      "id": "entry_93_ADD_PENDING_RECRUITMENT_ACTION",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "ADD_PENDING_RECRUITMENT_ACTION",
        "payload": {
          "unitId": "rec_violet_3_3_6",
          "actionType": "UNIT_RECRUITMENT",
          "quarterHexKey": "3,6",
          "price": 2,
          "sizeAdded": 0
        }
      }
    },
    {
      "id": "entry_94_ADD_PENDING_RECRUITMENT_ACTION",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "ADD_PENDING_RECRUITMENT_ACTION",
        "payload": {
          "unitId": "rec_violet_3_3_6",
          "actionType": "SIZE_RECRUITMENT",
          "quarterHexKey": "3,6",
          "price": 2,
          "sizeAdded": 1
        }
      }
    },
    {
      "id": "entry_95_ADD_PENDING_RECRUITMENT_ACTION",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "ADD_PENDING_RECRUITMENT_ACTION",
        "payload": {
          "unitId": "rec_violet_3_3_6",
          "actionType": "SIZE_RECRUITMENT",
          "quarterHexKey": "3,6",
          "price": 2,
          "sizeAdded": 1
        }
      }
    },
    {
      "id": "entry_96_ADD_PENDING_RECRUITMENT_ACTION",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "ADD_PENDING_RECRUITMENT_ACTION",
        "payload": {
          "unitId": "rec_violet_3_3_6",
          "actionType": "SIZE_RECRUITMENT",
          "quarterHexKey": "3,6",
          "price": 2,
          "sizeAdded": 1
        }
      }
    },
    {
      "id": "entry_97_ADD_PENDING_RECRUITMENT_ACTION",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "ADD_PENDING_RECRUITMENT_ACTION",
        "payload": {
          "unitId": "rec_violet_3_3_6",
          "actionType": "SIZE_RECRUITMENT",
          "quarterHexKey": "3,6",
          "price": 2,
          "sizeAdded": 1
        }
      }
    },
    {
      "id": "entry_98_ADD_PENDING_RECRUITMENT_ACTION",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "ADD_PENDING_RECRUITMENT_ACTION",
        "payload": {
          "unitId": "rec_violet_3_3_6",
          "actionType": "SIZE_RECRUITMENT",
          "quarterHexKey": "3,6",
          "price": 2,
          "sizeAdded": 1
        }
      }
    },
    {
      "id": "entry_99_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_100_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_101_MOVE_UNIT",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_violet_10_2_3",
          "unitType": "unit_d8",
          "newHexKey": "1,3"
        }
      }
    },
    {
      "id": "entry_102_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_violet_10_2_3",
          "fromHexKey": "0,2",
          "toHexKey": "1,3",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_103_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_104_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "shooting",
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_105_APPLY_SHOOTING_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_SHOOTING_ACTIONS"
      }
    },
    {
      "id": "entry_106_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_107_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_108_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_109_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_110_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 3,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_111_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 3,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_112_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 3,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "agrarianism",
            "name": "Аграризм",
            "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
            "implemented": true
          },
          "round": 3,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_113_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,5",
          "unitId": "u_violet_6_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_114_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "3,4",
          "unitId": "u_violet_10_2_3",
          "unitHexKey": "1,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_115_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,6",
          "unitId": "u_violet_7_2_5",
          "unitHexKey": "2,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_116_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,5",
          "unitId": "u_violet_8_3_5",
          "unitHexKey": "3,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_117_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,7",
          "unitId": "rec_violet_3_3_6",
          "unitHexKey": "3,6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_118_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,7",
          "unitId": "u_violet_9_2_6",
          "unitHexKey": "2,6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_119_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_120_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,2",
          "unitId": "u_orange_11_6_2",
          "unitHexKey": "6,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_121_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,1",
          "unitId": "u_orange_11_6_2",
          "unitHexKey": "6,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_122_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_123_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "despotism",
            "name": "Деспотизм",
            "description": "Скидка на найм отрядов\nСкидка на постройку Лагеря",
            "implemented": true
          },
          "round": 4,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_124_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_125_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_126_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "agrarianism",
            "name": "Аграризм",
            "description": "Скидка на Ферму и Склад\nОбмен снабжения на монеты",
            "implemented": true
          },
          "round": 4,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_127_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_128_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_129_MOVE_UNIT",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_violet_10_2_3",
          "unitType": "unit_d8",
          "newHexKey": "2,3"
        }
      }
    },
    {
      "id": "entry_130_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_violet_10_2_3",
          "fromHexKey": "1,3",
          "toHexKey": "2,3",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_131_MOVE_UNIT",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "rec_violet_3_3_6",
          "unitType": "unit_d6",
          "newHexKey": "3,4"
        }
      }
    },
    {
      "id": "entry_132_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "rec_violet_3_3_6",
          "fromHexKey": "3,6",
          "toHexKey": "3,4",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_133_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_134_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "shooting",
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_135_APPLY_SHOOTING_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_SHOOTING_ACTIONS"
      }
    },
    {
      "id": "entry_136_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_137_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_138_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_139_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_140_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 4,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_141_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 4,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_142_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 4,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "servarianism",
            "name": "Серваризм",
            "description": "Увеличенный доход рудников,\nсмежных казармам и крупными отрядам",
            "implemented": true
          },
          "round": 4,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_143_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "3,4",
          "unitId": "u_violet_6_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_144_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,5",
          "unitId": "u_violet_10_2_3",
          "unitHexKey": "2,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_145_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,6",
          "unitId": "u_violet_7_2_5",
          "unitHexKey": "2,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_146_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,5",
          "unitId": "u_violet_8_3_5",
          "unitHexKey": "3,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_147_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,7",
          "unitId": "u_violet_9_2_6",
          "unitHexKey": "2,6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_148_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,7",
          "unitId": "rec_violet_3_3_6",
          "unitHexKey": "3,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_149_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_150_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,2",
          "unitId": "u_orange_11_6_2",
          "unitHexKey": "6,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_151_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,1",
          "unitId": "u_orange_11_6_2",
          "unitHexKey": "6,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_152_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_153_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "isolationism",
            "name": "Изоляционизм",
            "description": "Защита права первого хода\nСкидка на особые строения\nБонус к урону отрядов в своих городах",
            "implemented": true
          },
          "round": 5,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_154_SET_HEX_TOKEN",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_HEX_TOKEN",
        "payload": {
          "key": "4,4",
          "tokenType": "farm",
          "price": 3,
          "isCommiting": false,
          "isFreeAction": false
        }
      }
    },
    {
      "id": "entry_155_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_156_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_157_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "servarianism",
            "name": "Серваризм",
            "description": "Увеличенный доход рудников,\nсмежных казармам и крупными отрядам",
            "implemented": true
          },
          "round": 5,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_158_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_159_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_160_MOVE_UNIT",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_violet_10_2_3",
          "unitType": "unit_d8",
          "newHexKey": "3,3"
        }
      }
    },
    {
      "id": "entry_161_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_violet_10_2_3",
          "fromHexKey": "2,3",
          "toHexKey": "3,3",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_162_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_163_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "shooting",
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_164_APPLY_SHOOTING_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_SHOOTING_ACTIONS"
      }
    },
    {
      "id": "entry_165_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_166_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_167_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_168_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_169_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 5,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_170_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 5,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_171_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 5,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "servarianism",
            "name": "Серваризм",
            "description": "Увеличенный доход рудников,\nсмежных казармам и крупными отрядам",
            "implemented": true
          },
          "round": 5,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "e_172_replica",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "«Луцию Аврелию — Луций Корнелий: привет. Говорят, ты перешёл речку. Браво: в наше время решительность — редкость, я коллекционирую редкости. Теперь послушай коллегу по имени. Рим не захвачен, Рим — СПАСЁН: я перечислю. Хлеб — есть. Порядок — есть. Долги — реструктурированы (выучи это слово, оно тебе понадобится). Цена — гарнизоны и вывеска. Вывеска, Луций! Ты четыре года платил кровью — я плачу вывеской, и меня же зовут предателем. Иди в Рим ГОСТЕМ: консульство — твоё, триумф — твой, история нас рассудит и, как всегда, оправдает удобнейшего. Твой — в самом выгодном смысле слова — Сулла».",
        "characterName": "Сулла",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m6_sulla_charm.png"
      }
    },
    {
      "id": "e_173_replica",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Ответа не будет. Нет. Будет. Передайте на словах: «Рим не вывеска. Подпись: сын висевшего».",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m6_lucius_stern.png"
      }
    },
    {
      "id": "e_174_replica",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "«Сын висевшего»… Кимвр бы оценил. Смотри-ка, мальчик: ты начал подписываться чужими оскорблениями. Это называется «биография».",
        "characterName": "Барба",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m6_barba_grin.png"
      }
    },
    {
      "id": "entry_175_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "3,4",
          "unitId": "u_violet_6_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_176_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,5",
          "unitId": "u_violet_10_2_3",
          "unitHexKey": "3,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_177_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,6",
          "unitId": "u_violet_7_2_5",
          "unitHexKey": "2,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_178_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,5",
          "unitId": "rec_violet_3_3_6",
          "unitHexKey": "3,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_179_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,4",
          "unitId": "u_violet_8_3_5",
          "unitHexKey": "3,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_180_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,7",
          "unitId": "u_violet_9_2_6",
          "unitHexKey": "2,6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_181_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,7",
          "unitId": "u_violet_7_2_5",
          "unitHexKey": "2,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_182_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_183_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,1",
          "unitId": "u_orange_11_6_2",
          "unitHexKey": "6,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_184_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,1",
          "unitId": "u_orange_11_6_2",
          "unitHexKey": "6,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_185_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_186_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "industrialism",
            "name": "Индустриализм",
            "description": "Дополнительное действие\nв фазе Строительства\nСкидка на особые строения",
            "implemented": true
          },
          "round": 6,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_187_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_188_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_189_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "ecoanarchism",
            "name": "Экоанархизм",
            "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
            "implemented": true
          },
          "round": 6,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_190_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_191_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_192_MOVE_UNIT",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_violet_10_2_3",
          "unitType": "unit_d8",
          "newHexKey": "4,3"
        }
      }
    },
    {
      "id": "entry_193_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_violet_10_2_3",
          "fromHexKey": "3,3",
          "toHexKey": "4,3",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_194_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_195_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "shooting",
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_196_APPLY_SHOOTING_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_SHOOTING_ACTIONS"
      }
    },
    {
      "id": "entry_197_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_198_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_199_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_200_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_201_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 6,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_202_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 6,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_203_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 6,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "ecoanarchism",
            "name": "Экоанархизм",
            "description": "Пустые ячейки не ограничивают перемещение\nПередача снабжения в любую ячейку поля",
            "implemented": true
          },
          "round": 6,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_204_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "3,4",
          "unitId": "u_violet_6_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_205_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,5",
          "unitId": "u_violet_10_2_3",
          "unitHexKey": "4,3",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_206_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,6",
          "unitId": "u_violet_7_2_5",
          "unitHexKey": "2,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_207_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,5",
          "unitId": "rec_violet_3_3_6",
          "unitHexKey": "3,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_208_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,4",
          "unitId": "u_violet_8_3_5",
          "unitHexKey": "3,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_209_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,7",
          "unitId": "u_violet_9_2_6",
          "unitHexKey": "2,6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_210_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,7",
          "unitId": "u_violet_7_2_5",
          "unitHexKey": "2,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_211_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_212_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,1",
          "unitId": "u_orange_11_6_2",
          "unitHexKey": "6,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_213_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,1",
          "unitId": "u_orange_11_6_2",
          "unitHexKey": "6,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_214_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_215_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "theocracy",
            "name": "Теократия",
            "description": "Увеличенный доход храмов\nБонус к урону отрядов в городе с храмом",
            "implemented": true
          },
          "round": 7,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_216_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_217_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_218_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "despotism",
            "name": "Деспотизм",
            "description": "Скидка на найм отрядов\nСкидка на постройку Лагеря",
            "implemented": true
          },
          "round": 7,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_219_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_220_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_221_MOVE_UNIT",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_violet_10_2_3",
          "unitType": "unit_d8",
          "newHexKey": "4,4"
        }
      }
    },
    {
      "id": "entry_222_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_violet_10_2_3",
          "fromHexKey": "4,3",
          "toHexKey": "4,4",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_223_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_224_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "shooting",
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_225_APPLY_SHOOTING_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_SHOOTING_ACTIONS"
      }
    },
    {
      "id": "entry_226_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_227_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_228_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_229_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_230_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 7,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_231_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 7,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_232_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 7,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "isolationism",
            "name": "Изоляционизм",
            "description": "Защита права первого хода\nСкидка на особые строения\nБонус к урону отрядов в своих городах",
            "implemented": true
          },
          "round": 7,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_233_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "3,4",
          "unitId": "u_violet_6_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_234_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,4",
          "unitId": "u_violet_10_2_3",
          "unitHexKey": "4,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_235_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,5",
          "unitId": "u_violet_7_2_5",
          "unitHexKey": "2,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_236_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,6",
          "unitId": "u_violet_9_2_6",
          "unitHexKey": "2,6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_237_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,5",
          "unitId": "rec_violet_3_3_6",
          "unitHexKey": "3,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_238_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,7",
          "unitId": "u_violet_8_3_5",
          "unitHexKey": "3,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_239_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,7",
          "unitId": "u_violet_7_2_5",
          "unitHexKey": "2,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_240_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_241_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,2",
          "unitId": "u_orange_11_6_2",
          "unitHexKey": "6,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_242_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,1",
          "unitId": "u_orange_11_6_2",
          "unitHexKey": "6,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_243_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_244_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "patriotism",
            "name": "Патриотизм",
            "description": "Скидка на найм размера отрядов и Арсенал",
            "implemented": true
          },
          "round": 8,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_245_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_246_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_247_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "servarianism",
            "name": "Серваризм",
            "description": "Увеличенный доход рудников,\nсмежных казармам и крупными отрядам",
            "implemented": true
          },
          "round": 8,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_248_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_249_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_250_MOVE_UNIT",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "MOVE_UNIT",
        "payload": {
          "unitId": "u_violet_10_2_3",
          "unitType": "unit_d8",
          "newHexKey": "4,5"
        }
      }
    },
    {
      "id": "entry_251_ADD_PENDING_MOVEMENT_ACTION",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "ADD_PENDING_MOVEMENT_ACTION",
        "payload": {
          "unitId": "u_violet_10_2_3",
          "fromHexKey": "4,4",
          "toHexKey": "4,5",
          "additionalSupply": false
        }
      }
    },
    {
      "id": "entry_252_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_253_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "shooting",
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_254_APPLY_SHOOTING_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_SHOOTING_ACTIONS"
      }
    },
    {
      "id": "entry_255_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_256_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_257_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_258_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_259_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 8,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_260_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 8,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_261_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 8,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "fanaticism",
            "name": "Фанатизм",
            "description": "Увеличенный доход руин\nБонус к урону отрядов смежно с руинами\nОбмен очков на монеты",
            "implemented": true
          },
          "round": 8,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "e_262_replica",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "В четыре очереди, я сказал! Старики и дети — без очереди! Весы — НАШИ ставь, городские!.. Двадцать лет, легат. Двадцать лет я при складах — и первый раз ОТПИРАЮ. Знаешь, что страшно? ПОЛУЧАЕТСЯ. Быстрее, чем запирать, получается!",
        "characterName": "Салоний",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m6_salonius_work.png"
      }
    },
    {
      "id": "e_263_replica",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Вон там, у весов, — женщина с мальчиком. Видишь, как она хлеб берёт? Двумя руками, а смотрит — на тебя. Запомни этот взгляд, господин. За него воюют дольше, чем за золото. И предают — тоже за него.",
        "characterName": "Ильва",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m6_ilva_firm.png"
      }
    },
    {
      "id": "entry_264_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "3,4",
          "unitId": "u_violet_6_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_265_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,5",
          "unitId": "u_violet_10_2_3",
          "unitHexKey": "4,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_266_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,5",
          "unitId": "u_violet_7_2_5",
          "unitHexKey": "2,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_267_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,6",
          "unitId": "u_violet_9_2_6",
          "unitHexKey": "2,6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_268_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,4",
          "unitId": "rec_violet_3_3_6",
          "unitHexKey": "3,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_269_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,7",
          "unitId": "u_violet_8_3_5",
          "unitHexKey": "3,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_270_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,7",
          "unitId": "u_violet_7_2_5",
          "unitHexKey": "2,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_271_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_272_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,2",
          "unitId": "u_orange_11_6_2",
          "unitHexKey": "6,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_273_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,1",
          "unitId": "u_orange_11_6_2",
          "unitHexKey": "6,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_274_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_275_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "oligarchy",
            "name": "Олигархия",
            "description": "2 гильдий в одном городе\nУвеличенный доход гильдий",
            "implemented": true
          },
          "round": 9,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "e_276_replica",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Господин смотритель. Дом ценит людей, понимающих в складах и воротах. Понимающему — вес серебром: по весу ключей, которые… окажутся не заперты. Ночью. Любой ночью на ваш выбор.",
        "characterName": "Агент Дома Весов",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m6_agent.png"
      }
    },
    {
      "id": "e_277_replica",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Сударь, ты по адресу и не по адресу сразу. По адресу — потому что я вор, тут твои сведения верные. Не по адресу — потому что я двадцать лет ворую У СВОИХ. Своих — не продаю. Стража! Проводите господина весовщика до дороги. Вежливо: он гость. Был.",
        "characterName": "Салоний",
        "side": "right",
        "characterImage": "/img/campaigns/humans/m6_salonius_firm.png"
      }
    },
    {
      "id": "entry_278_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_279_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_280_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "totalitarianism",
            "name": "Тоталитаризм",
            "description": "Очки за военные строения\nСкидка на Лагерь и Арсенал\nНайм отрядов увеличенного размера",
            "implemented": true
          },
          "round": 9,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_281_RECRUIT_UNIT",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "RECRUIT_UNIT",
        "payload": {
          "hexKey": "3,6",
          "unitType": "unit_d6",
          "factionId": "humans",
          "price": 2,
          "unitId": "rec_violet_9_3_6"
        }
      }
    },
    {
      "id": "entry_282_ADD_PENDING_RECRUITMENT_ACTION",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "ADD_PENDING_RECRUITMENT_ACTION",
        "payload": {
          "unitId": "rec_violet_9_3_6",
          "actionType": "UNIT_RECRUITMENT",
          "quarterHexKey": "3,6",
          "price": 2,
          "sizeAdded": 0
        }
      }
    },
    {
      "id": "entry_283_ADD_PENDING_RECRUITMENT_ACTION",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "ADD_PENDING_RECRUITMENT_ACTION",
        "payload": {
          "unitId": "rec_violet_9_3_6",
          "actionType": "SIZE_RECRUITMENT",
          "quarterHexKey": "3,6",
          "price": 2,
          "sizeAdded": 1
        }
      }
    },
    {
      "id": "entry_284_ADD_PENDING_RECRUITMENT_ACTION",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "ADD_PENDING_RECRUITMENT_ACTION",
        "payload": {
          "unitId": "rec_violet_9_3_6",
          "actionType": "SIZE_RECRUITMENT",
          "quarterHexKey": "3,6",
          "price": 2,
          "sizeAdded": 1
        }
      }
    },
    {
      "id": "entry_285_ADD_PENDING_RECRUITMENT_ACTION",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "ADD_PENDING_RECRUITMENT_ACTION",
        "payload": {
          "unitId": "rec_violet_9_3_6",
          "actionType": "SIZE_RECRUITMENT",
          "quarterHexKey": "3,6",
          "price": 2,
          "sizeAdded": 1
        }
      }
    },
    {
      "id": "entry_286_ADD_PENDING_RECRUITMENT_ACTION",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "ADD_PENDING_RECRUITMENT_ACTION",
        "payload": {
          "unitId": "rec_violet_9_3_6",
          "actionType": "SIZE_RECRUITMENT",
          "quarterHexKey": "3,6",
          "price": 2,
          "sizeAdded": 1
        }
      }
    },
    {
      "id": "entry_287_ADD_PENDING_RECRUITMENT_ACTION",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "ADD_PENDING_RECRUITMENT_ACTION",
        "payload": {
          "unitId": "rec_violet_9_3_6",
          "actionType": "SIZE_RECRUITMENT",
          "quarterHexKey": "3,6",
          "price": 2,
          "sizeAdded": 1
        }
      }
    },
    {
      "id": "entry_288_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_289_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_290_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_291_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "shooting",
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_292_APPLY_SHOOTING_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_SHOOTING_ACTIONS"
      }
    },
    {
      "id": "entry_293_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_294_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_295_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_296_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_297_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 9,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_298_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 9,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_299_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 9,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "barbarism",
            "name": "Варварство",
            "description": "Бесплатный наем Пехоты\nУвеличенный урон в ближнем бою\nОчки за урон",
            "implemented": true
          },
          "round": 9,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "e_300_replica",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Из Рима, легат. Эдикт курии… «Луций Аврелий Скавр объявляется врагом отечества. Всякий, давший ему кров, хлеб или воду, разделит его участь». Подписи… половина подписей мне знакома, легат. Друзья твоего отца — тоже там.",
        "characterName": "Требоний",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m6_trebonius.png"
      }
    },
    {
      "id": "e_301_replica",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Значит, врагом отечества… Слышали?! Отныне всякий, кто даст мне хлеба, — враг Рима! Кто хочет уйти — уходит сейчас, свободно, с жалованьем. Кто останется — запомните это утро. Нас назвали врагами отечества те, кто сдал отечество в залог. Идём взыскивать.",
        "characterName": "Луций",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m6_lucius_resolve.png"
      }
    },
    {
      "id": "e_302_replica",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "blue"
      },
      "kind": "replica",
      "replica": {
        "text": "Армия!.. По списку — ни одного убывшего. Разреши продолжать, легат.",
        "characterName": "Атилий",
        "side": "left",
        "characterImage": "/img/campaigns/humans/m6_atilius_calm.png"
      }
    },
    {
      "id": "entry_303_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "3,4",
          "unitId": "u_violet_6_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_304_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,5",
          "unitId": "u_violet_10_2_3",
          "unitHexKey": "4,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_305_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,5",
          "unitId": "u_violet_7_2_5",
          "unitHexKey": "2,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_306_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,6",
          "unitId": "u_violet_9_2_6",
          "unitHexKey": "2,6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_307_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,4",
          "unitId": "rec_violet_3_3_6",
          "unitHexKey": "3,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_308_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,7",
          "unitId": "rec_violet_9_3_6",
          "unitHexKey": "3,6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_309_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,7",
          "unitId": "u_violet_8_3_5",
          "unitHexKey": "3,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_310_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_311_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,2",
          "unitId": "u_orange_11_6_2",
          "unitHexKey": "6,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_312_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,1",
          "unitId": "u_orange_11_6_2",
          "unitHexKey": "6,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_313_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_314_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "industrialism",
            "name": "Индустриализм",
            "description": "Дополнительное действие\nв фазе Строительства\nСкидка на особые строения",
            "implemented": true
          },
          "round": 10,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_315_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_316_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_317_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "hegemonism",
            "name": "Гегемонизм",
            "description": "Бонус к доходу очков и урону в центре поля",
            "implemented": true
          },
          "round": 10,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_318_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_319_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_320_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_321_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "shooting",
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_322_APPLY_SHOOTING_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_SHOOTING_ACTIONS"
      }
    },
    {
      "id": "entry_323_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_324_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_325_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_326_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_327_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 10,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_328_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 10,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_329_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 10,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "despotism",
            "name": "Деспотизм",
            "description": "Скидка на найм отрядов\nСкидка на постройку Лагеря",
            "implemented": true
          },
          "round": 10,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_330_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "3,4",
          "unitId": "u_violet_6_2_4",
          "unitHexKey": "2,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_331_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,5",
          "unitId": "u_violet_10_2_3",
          "unitHexKey": "4,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_332_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,5",
          "unitId": "u_violet_7_2_5",
          "unitHexKey": "2,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_333_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,6",
          "unitId": "u_violet_9_2_6",
          "unitHexKey": "2,6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_334_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,4",
          "unitId": "rec_violet_3_3_6",
          "unitHexKey": "3,4",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_335_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "2,7",
          "unitId": "rec_violet_9_3_6",
          "unitHexKey": "3,6",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_336_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "1,7",
          "unitId": "u_violet_8_3_5",
          "unitHexKey": "3,5",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_337_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_violet",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_338_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "4,2",
          "unitId": "u_orange_11_6_2",
          "unitHexKey": "6,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_339_DISTRIBUTE_SUPPLY",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "DISTRIBUTE_SUPPLY",
        "payload": {
          "farmHexKey": "6,1",
          "unitId": "u_orange_11_6_2",
          "unitHexKey": "6,2",
          "isAutoSupply": true
        }
      }
    },
    {
      "id": "entry_340_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_341_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "supply",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "despotism",
            "name": "Деспотизм",
            "description": "Скидка на найм отрядов\nСкидка на постройку Лагеря",
            "implemented": true
          },
          "round": 11,
          "currentPlayerId": "player_id_orange",
          "phase": "supply",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_342_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "construction",
        "stage": null,
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_violet",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_343_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_344_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "construction",
        "stage": null,
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "theocracy",
            "name": "Теократия",
            "description": "Увеличенный доход храмов\nБонус к урону отрядов в городе с храмом",
            "implemented": true
          },
          "round": 11,
          "currentPlayerId": "player_id_orange",
          "phase": "construction",
          "warPhaseStage": null
        }
      }
    },
    {
      "id": "entry_345_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_346_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_347_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_348_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "violet"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "shooting",
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_349_APPLY_SHOOTING_ACTIONS",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "violet"
      },
      "action": {
        "type": "APPLY_SHOOTING_ACTIONS"
      }
    },
    {
      "id": "entry_350_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "violet",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "shooting",
        "playerColor": "violet"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_violet",
          "phase": "war",
          "warPhaseStage": "shooting"
        }
      }
    },
    {
      "id": "entry_351_APPLY_RECRUITMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_RECRUITMENT_ACTIONS"
      }
    },
    {
      "id": "entry_352_SET_WAR_PHASE_STAGE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "recruitment",
        "playerColor": "orange"
      },
      "action": {
        "type": "SET_WAR_PHASE_STAGE",
        "payload": {
          "stage": "movement",
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "recruitment"
        }
      }
    },
    {
      "id": "entry_353_APPLY_MOVEMENT_ACTIONS",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "APPLY_MOVEMENT_ACTIONS"
      }
    },
    {
      "id": "entry_354_COMPLETE_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "COMPLETE_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "round": 11,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    },
    {
      "id": "entry_355_CAPTURE_CITIES",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "CAPTURE_CITIES",
        "payload": {
          "round": 11,
          "phase": "war"
        }
      }
    },
    {
      "id": "entry_356_START_NEXT_PHASE",
      "kind": "action",
      "playerColor": "orange",
      "moment": {
        "round": 11,
        "phase": "war",
        "stage": "movement",
        "playerColor": "orange"
      },
      "action": {
        "type": "START_NEXT_PHASE",
        "payload": {
          "timestamp": 1700000000000,
          "newPolicy": {
            "id": "oligarchy",
            "name": "Олигархия",
            "description": "2 гильдий в одном городе\nУвеличенный доход гильдий",
            "implemented": true
          },
          "round": 11,
          "currentPlayerId": "player_id_orange",
          "phase": "war",
          "warPhaseStage": "movement"
        }
      }
    }
  ],
  "objectives": [
    {
      "id": "h6_cross_rubicon",
      "type": "build_central_quarter",
      "params": {
        "hexKey": "0,1"
      },
      "text": "Поставь лагерь за Рубиконом — у старой ветлы за бродом: без него хутора того берега не кормят армию",
      "isMain": true,
      "isFailure": false
    },
    {
      "id": "h6_take_ariminum",
      "type": "capture_city",
      "params": {
        "centralHexKey": "2,5"
      },
      "text": "Возьми Аримин",
      "isMain": true,
      "isFailure": false
    },
    {
      "id": "h6_hear_rome",
      "type": "survive_rounds",
      "params": {
        "rounds": 11
      },
      "text": "Выслушай Рим",
      "isMain": true,
      "isFailure": false
    },
    {
      "id": "h6_break_tutela",
      "type": "destroy_all_enemy_units",
      "params": {
        "color": "violet"
      },
      "text": "Разбей когорты Суллы — гарнизон «Опеки» в Аримине",
      "isMain": false,
      "isFailure": false
    },
    {
      "id": "h6_open_granaries",
      "type": "unit_reaches_hex",
      "params": {
        "hexKey": "6,2"
      },
      "text": "Дойди отрядом до хлебных складов Дома Весов у порта",
      "isMain": false,
      "isFailure": false
    },
    {
      "id": "h6_lose_camp",
      "type": "lose_city",
      "params": {
        "centralHexKey": "-2,-3"
      },
      "text": "Не потеряй северный лагерь",
      "isMain": false,
      "isFailure": true
    }
  ]
};

export default mission;
